import { PackageOpen, type LucideIcon } from 'lucide-react'
import { cn } from '@utils'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  className?: string
}

const EmptyState = ({ icon: Icon = PackageOpen, title, description, className }: EmptyStateProps) => (
  <div className={cn('flex flex-col items-center justify-center text-center py-12 px-4 animate-fade-up', className)}>
    <div
      className="flex items-center justify-center rounded-full mb-5 h-20 w-20"
      style={{ backgroundColor: 'var(--theme-primary-light)', color: 'var(--theme-color)' }}>
      <Icon size={34} strokeWidth={1.75} aria-hidden />
    </div>
    <p className="text-fluid-lg font-medium" style={{ color: 'var(--text-color)' }}>
      {title}
    </p>
    {description && (
      <p className="text-fluid-sm mt-1.5 max-w-xs leading-relaxed" style={{ color: 'var(--light-text-color)' }}>
        {description}
      </p>
    )}
  </div>
)

export default EmptyState
